/**
 * Why Finish arrival container is blocked on the receiving kiosk.
 * Copy matches the server checks in shipping-inbound-receive-arrival-finish.ts.
 */
export function inboundReceiveFinishArrivalBlockReason(input: {
  receiptReadOnly: boolean;
  hasScannedArrivalPackage: boolean;
  openContainerCount: number;
  countedTotal: number;
  hasPackingSlip: boolean;
}): string | null {
  if (input.receiptReadOnly) {
    return "This arrival crate is already finished.";
  }
  if (!input.hasScannedArrivalPackage) {
    return "Scan the dock crate tag before finishing this arrival container.";
  }
  if (input.openContainerCount > 0) {
    return "Seal and print every open inventory container before finishing this arrival crate.";
  }
  if (input.countedTotal <= 0) {
    return "Count quantity onto a line before finishing this arrival container.";
  }
  if (!input.hasPackingSlip) {
    return "Upload a packing slip before finishing this arrival container.";
  }
  return null;
}
